import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Text, SvgIcon } from "@cinch-labs/design-system";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import Image from "next/image";
import styles from "./store-hero.module.css";
import { Wrapper } from "@cinch-nx/shared-ui";
export var StoreHero = function(blok) {
    var title = blok.title, subtitle = blok.subtitle, image = blok.image, address = blok.address, telephoneNumber = blok.telephoneNumber;
    var hasImageFilename = image === null || image === void 0 ? void 0 : image.filename;
    var ref;
    return /*#__PURE__*/ _jsxs(Wrapper, _object_spread_props(_object_spread({}, storyblokEditable(blok)), {
        isSlim: true,
        className: {
            inner: styles.root
        },
        children: [
            hasImageFilename && /*#__PURE__*/ _jsx("div", {
                className: styles.imageWrapper,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: image === null || image === void 0 ? void 0 : image.filename,
                    alt: (ref = image === null || image === void 0 ? void 0 : image.alt) !== null && ref !== void 0 ? ref : undefined,
                    layout: "fill",
                    priority: true,
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.content,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        element: "h1",
                        className: styles.title,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: styles.body,
                        children: subtitle
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.divider
                    }),
                    /*#__PURE__*/ _jsxs("address", {
                        className: styles.contactInformation,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.contactItem,
                                children: [
                                    /*#__PURE__*/ _jsx(SvgIcon, {
                                        name: "location",
                                        size: 24,
                                        className: styles.svg
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: address
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.contactItem,
                                children: [
                                    /*#__PURE__*/ _jsx(SvgIcon, {
                                        name: "phone",
                                        size: 24,
                                        className: styles.svg
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: telephoneNumber
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
